/*
 * @Description: 公司信息store
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2023-05-25 11:34:08
 * @LastEditors: Monkey
 * @LastEditTime: 2023-05-25 15:31:03
 */
import tool from '@/utils/tool';

const KEY_COMPANY_INFO = "COMPANY_INFO";
const getCompanyParam = (key) => {
  const companyInfo = tool.data.get(KEY_COMPANY_INFO);
  return companyInfo === undefined || companyInfo === null ? '' : companyInfo[key];
};

export default {
  namespaced: true,
  state: {
    // 公司名称
    name: getCompanyParam('name'),
    // 公司联系人
    person: getCompanyParam('person'),
    // 公司联系电话
    tel: getCompanyParam('tel'),
  },
  mutations: {
    setCompany(state, company) {
      tool.data.set(KEY_COMPANY_INFO, company);
      state.name = company.name;
      state.person = company.person;
      state.tel = company.tel;
    }
  },
  actions: {
    saveCompany({ commit }, company) {
      return new Promise((resolve) => {
        commit('setCompany', company);
        resolve();
      });
    }
  }
}